module.exports = __webpack_public_path__ + "static/assets/77a9f6ae8e434e5955a2a9fb3b0eed49.png";